import { createContext, ReactNode, useContext, useState } from "react";
import { BseDto, NegotiationRoundDto } from "../../../../autogen/bff-api";
import { getCurrentRound, getLatestRound, getLatestRoundNumber } from "../../common/negotiation-utils";

interface NegotiationContextType {
  roundNumber: number;
  setRoundNumber: (round: number) => void;
  currentRound: NegotiationRoundDto | undefined;
  latestRound: NegotiationRoundDto | undefined;
  event: BseDto;
}

const NegotiationContext = createContext<NegotiationContextType | undefined>(undefined);

export const NegotiationProvider = ({ children, event }: { children: ReactNode; event: BseDto }) => {
  const [roundNumber, setRoundNumber] = useState(getLatestRoundNumber(event.negotiationContext ?? undefined));

  const currentRound = getCurrentRound(roundNumber, event.negotiationContext?.rounds);
  const latestRound = getLatestRound(event.negotiationContext?.rounds);

  return (
    <NegotiationContext.Provider
      value={{
        roundNumber,
        setRoundNumber,
        currentRound,
        latestRound,
        event,
      }}
    >
      {children}
    </NegotiationContext.Provider>
  );
};

export const useNegotiation = (): NegotiationContextType => {
  const context = useContext(NegotiationContext);
  if (context === undefined) {
    throw new Error("useNegotiation must be used within a NegotiationProvider");
  }
  return context;
};
